import React from 'react';

function ListOrdered() {
  return (
    <svg
      width='18'
      height='19'
      viewBox='0 0 18 19'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M7.5 13.25H15M3 12.264V12.125C3 11.5037 3.50368 11 4.125 11H4.15541C4.75993 11 5.25016 11.4901 5.25016 12.0946C5.25016 12.3578 5.16465 12.6139 5.00676 12.8245L3 15.5001L5.25 15.5M7.5 9.5H15M7.5 5.75H15M3 4.25L4.5 3.5V8'
        stroke='black'
        stroke-width='1.5'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    </svg>
  );
}

export default ListOrdered;
